/** @format */

export * from './product-card.module';
